import { FC, ReactNode } from 'react';
import classNames from 'classnames';
import { Field, FieldProps, FieldRenderProps } from 'react-final-form';
import { QuillInput } from 'components/QuillInput';

interface Props extends FieldProps<HTMLInputElement, FieldRenderProps<any>> {
  name: string;
  label?: ReactNode;
  disabled?: boolean;
  validate?: (value: any) => string | undefined;
  placeholder?: string;
}

export const DescriptionField: FC<Props> = ({ label, name, validate, placeholder, ...props }) => {
  return (
    <Field name={name} validate={validate} allowNull {...props}>
      {({ input, meta }) => {
        const hasError = (meta.error || meta.submitError) && meta.dirty;

        return (
          <div className={classNames('form-group', { 'has-danger': hasError })}>
            <div>
              <label htmlFor={name}>{label}</label>
              <QuillInput
                id={name}
                value={input.value || ''}
                onChange={input.onChange}
                valueState={hasError ? 'has-danger' : ''}
                placeholder={placeholder}
              />
              {hasError && (
                <label htmlFor={name} className="error">
                  {meta.error || meta.submitError}
                </label>
              )}
            </div>
          </div>
        );
      }}
    </Field>
  );
};
